module.exports = __webpack_public_path__ + "assets/normal/images/share6.e68ca0a8.png";